<template>
  <ekitabu-select
    id="school-select"
    v-model="currentValue"
    :items="sortedSchools"
    item-text="name"
    item-value="_id"
    :label="$t('checkout.delivery.school')"
    :placeholder="$t('checkout.delivery.selectSchool')"
    :class="compact ? null : 'mt-3'"
    :rules="selectRules"
    :required="required"
    :clearable="clearable"
    :disabled="disabled"
  />
</template>

<script>
import EkitabuSelect from "@/components/EkitabuSelect";
import gql from "graphql-tag";
import { sortSchoolsByName } from "@/helpers/schoolHelper";

export default {
  name: "SchoolSelect",
  components: {
    EkitabuSelect,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // Drops the legacy top margin so the select aligns in dense form grids.
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  computed: {
    selectRules() {
      return this.rules !== null ? this.rules : (this.required ? 'required' : null);
    },
    sortedSchools() {
      return sortSchoolsByName(this.schools);
    },
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    },
    currentValue(newValue) {
      this.$emit("input", newValue);
    },
  },
  apollo: {
    schools: {
      query: gql`
        query {
          schools {
            id
            _id
            name
          }
        }
      `,
    },
  },
}
</script>